import { styled } from '@mui/material';

import ActionButton from '@components/ActionButton';

export const StyledScrollButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible?: boolean }>(({ isVisible }) => ({
  display: isVisible ? 'flex' : 'none',
  position: 'fixed',
  right: '5%',
  bottom: '7.5rem',
  padding: 0,
  height: '48px',
  minWidth: '48px',
}));
